module.exports = __webpack_public_path__ + "static/media/sl_marker_police_hover.43997805.svg";